import { render } from "./IconLargeArrow.vue?vue&type=template&id=31ab4296"
import script from "./IconLargeArrow.vue?vue&type=script&lang=js"
export * from "./IconLargeArrow.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__